<template lang="pug">
  .payment-method
    component.preview(:is="component" v-bind="properties" @click.prevent.stop="select")
      .icon
        svg(
          v-if="active"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        )
          //- d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
          //- d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          path(
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.3"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          )
        .empty-checkbox(v-else)
          .circle
      .data
        .field-preview
          .label(v-if="showLabel") Zahlungsart
          .field-value {{ data.name }}
      template(v-if="active")
        .details.paypal(v-if="data.service === 'paypal'")
          Spinner(v-if="loading === true" :size="8" :thickness="3")
          PayPal(v-else :valid="valid" @validate="$emit('validate')")
        .details.stripe(v-else-if="data.service === 'stripe'")
          | TODO
        .details.others(v-else)
          button.button.w-full.is-medium.create-purchase(@click="order") Zahlungspflichtig Bestellen
    hr.my-4(v-if="showDivider")
</template>

<script>
import Vue from 'vue';

import { mapGetters, mapActions } from 'vuex';
import { get } from '@/helpers';

import PayPal from './PayPal';

export default {
    name: 'PaymentMethod',
    props: {
        data: {
            type: Object,
            required: true
        },
        active: {
            type: Boolean,
            default: false
        },
        showDivider: {
            type: Boolean,
            default: false
        },
        showLabel: {
            type: Boolean,
            default: false
        },
        valid: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        loading: undefined,
        error: undefined
    }),
    components: {
        PayPal
    },
    computed: {
        component() {
            let component = 'a';
            if (this.active) component = 'div';
            return component;
        },
        properties() {
            let properties = {};
            if (this.component === 'a') {
                properties.href = '#';
            }
            return properties;
        },
        currency() {
            return (
                get(this.customer, 'customerGroup.currency.iso4217') ||
                get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
                'EUR'
            );
        },
        ...mapGetters({
            customer: 'shop/customer',
            defaultCustomerGroup: 'shop/defaultCustomerGroup',
            payPalKeys: 'payPalKeys'
        })
    },
    methods: {
        select() {
            if (!this.active) {
                this.$emit('select', this.data);
            }
        },
        order() {
            if (this.valid) {
                this.submit();
            } else {
                this.$emit('validate');
            }
        },
        ...mapActions({
            submit: 'shop/submitCheckoutForm'
            // addMessage: 'message/add'
        })
    },
    beforeMount() {
        this.loading = true;
        switch (this.data.service) {
            case 'paypal': {
                const clientID = this.payPalKeys[this.data.environment];
                // NOTE: https://developer.paypal.com/docs/checkout/reference/customize-sdk/#enable-funding
                const enable3rdPartyMethods = 'giropay,sepa,sofort'; // TODO: get from shop settings
                const src = `https://www.paypal.com/sdk/js?client-id=${clientID}&currency=${this.currency}&enable-funding=${enable3rdPartyMethods}`;
                if (document.querySelectorAll(`head script[src="${src}"]`).length <= 0) {
                    const script = document.createElement('script');
                    script.setAttribute('src', src);
                    script.onload = () => {
                        const PaypalButtons = window.paypal.Buttons.driver('vue', Vue);
                        Vue.component('PaypalButtons', PaypalButtons);

                        this.$nextTick(() => {
                            this.loading = false;
                            this.error = false;
                        });
                    };
                    script.onerror = () => {
                        this.loading = false;
                        this.error = true;
                    };
                    document.head.appendChild(script);
                } else {
                    this.loading = false;
                    const PaypalButtons = window.paypal.Buttons.driver('vue', Vue);
                    Vue.component('PaypalButtons', PaypalButtons);
                }
                break;
            }
            case 'stripe': {
                // TODO
                this.loading = false;
                break;
            }
            default: {
                this.loading = false;
            }
        }
    }
};
</script>

<style lang="sass" scoped>
.empty-checkbox
  @apply flex justify-center items-center
  width: 3rem
  height: 3rem
  .circle
    @apply border-2 border-gray-400
    width: 1.5rem
    height: 1.5rem
    border-radius: 50%

.spinner-container
  min-height: 4rem
</style>
